export const AUTH_SUCCESSFUL_KEY: string = 'PROBATIX_AUTH'
